import { requestBuilder } from '../../http/RequestBuilder';

/** No JSON body fields — POST is a trigger only */
type PlaidOAuthTestTriggerBody = Record<string, never>;

interface PlaidOAuthTestTriggerResponse {
    redirectUri: string;
}

const usePlaidOAuthTestTrigger = requestBuilder.mutation<
    PlaidOAuthTestTriggerResponse,
    PlaidOAuthTestTriggerBody
>({
    endpoint: '/api/oauth/plaid/test-trigger',
    method: 'POST',
});

export default usePlaidOAuthTestTrigger;
